import type { FaireThemeEntity } from "../../entity_types/theme";

export const empowered_california_crystals: FaireThemeEntity = {
  token: "empowered-california-crystals",
  type: "theme",
  name: "Empowered California Crystals",
  description: "Bring a touch of Southern California sunshine and purpose to your DC storefront. These minerals come from a brand that supports feline rescue and celebrates women-owned business values.",
  teaser: "Your profile highlights a preference for high-quality, artisanal, and sustainable signals. Supporting a women-owned brand that 'gives back' aligns perfectly with your gift shop's community-oriented ethos.",
  detail: "The additional context features The Crystal Tabby, a women-owned, AAPI-owned SoCal business that leverages their crystal wholesale operations to foster rescue cats.",
  bgColor: "#F0E4D4",
  tileBgColor: "#6b5036",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_taaq4urqc2",
    "p_ut4y2ckn4j",
    "p_p8gryyqreu",
    "p_p8zf35esgw",
    "p_4snuqcrty5",
    "p_udxksueucd",
    "p_e8np3hwxg3",
    "p_tnsphxruwm",
    "p_rsbw4dytdt",
    "p_b54p69k5dz",
    "p_dvnpxx39by",
    "p_by43dx7nrt",
    "p_cpxa6q27s7",
    "p_spy7twrxnz",
    "p_sdbskqppw9",
    "p_rjar8wcagd",
    "p_d8mz68m87x",
    "p_2qnc9twv45",
    "p_vw4db65bzy",
    "p_5u2tyuprpa",
    "p_f6mz2ksjsm",
    "p_tryaj5zpn7",
    "p_nepeacpue3",
    "p_2h8j98yzce",
    "p_g254w6nqc3",
    "p_wadws4e9b9",
    "p_buptewzwhs",
    "p_7gkbze6mjm",
    "p_tp7rrppd5p",
    "p_sn9zg5tqwh",
    "p_9mjc7rd579",
    "p_svajbjcywb",
    "p_b99zx54aqy",
    "p_h5uqe2bc2q",
    "p_5xx7exzjwu",
    "p_v34vuaa3dz",
    "p_kgqruedjag",
    "p_mk822h2r2s",
    "p_k7y9hhxava",
    "p_s7mmax23bu",
    "p_39xx77frpz",
    "p_5u4wm8xk55",
    "p_rpkkfvsm9k",
    "p_md46uzruhg",
    "p_qwzy2f6d9b",
    "p_aa7ex4avg2",
    "p_m48apzyke8",
    "p_3qax8p8x79",
    "p_75y3yntsrq",
    "p_9cmx5brs8d",
    "p_kgp4svkrra",
    "p_puv5fb6gs4",
    "p_bnaxct7cg4",
    "p_4n93vwxpjm",
    "p_dvprzx5m2y",
    "p_e9h8jtznjy",
    "p_7fyqpevyy8",
    "p_mfd5uyafku",
    "p_k33skrrqn5",
    "p_t2e8n9jr3v",
    "p_5y9d67297n",
    "p_djdymc63sz",
    "p_vrvm57q8su",
    "p_efnzy9f57a",
    "p_vwqhzqsz2s",
    "p_hqbevzgdqf",
    "p_zsqxd6vgnt",
    "p_ru9j325nhf",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
